mapSite('.btn-map-site', '.item-menu-map-site')

function mapSite(btnMapMenu, itemMenu) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    selectAll(btnMapMenu).forEach(btn => {
        var dataMenu = btn.getAttribute('data-menu-sub');

        btn.addEventListener('click', ()=> select(`${itemMenu}#${dataMenu}`)?.classList.toggle('active'))
    })


}
